import {HeaderColumn, Row} from '@vidazoo/ui-kit';
import {observer} from 'mobx-react';
import {UserNotificationSettingsTableColumns} from '../common/constants';
import {ReactComponent as SearchIcon} from '../../../../charts/list/assets/search-small.svg';
import {ReactComponent as ClearIcon} from '../../../../charts/list/assets/cancel-small.svg';
import {ReactComponent as IncreaseIcon} from '../../../../charts/list/assets/increase-small.svg';
import {ReactComponent as DecreaseIcon} from '../../../../charts/list/assets/decrease-small.svg';

const icons = {'icon-search': SearchIcon, 'icon-cancel-small': ClearIcon,
    'icon-increase-small': IncreaseIcon, 'icon-decrease-small': DecreaseIcon};
const renderIcon = (name: string, size: number) => {
    const Icon = icons[name];
    return <Icon aria-hidden="true" style={{width: `${size}rem`, height: `${size}rem`}}/>;
};
export const SettingsTableHeader = observer(function SettingsTableHeader() {
    return <Row>{UserNotificationSettingsTableColumns.map(column =>
        <HeaderColumn key={column.key} colKey={column.key} appearance="classic" renderIcon={renderIcon}/>
    )}</Row>;
});
